/**
 * GroupApp
 * Root component for the group app.
 */
import React from 'react';

import PropTypes from 'prop-types';

import cookies from 'js/lib/cookie';

import PageHeader from 'bundles/page-header/components/PageHeader';
import SimpleCourseraMetatags from 'bundles/seo/components/SimpleCourseraMetatags';

import 'css!pages/groups/index';

class GroupPage extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    csrfToken: PropTypes.string.isRequired,
  };

  getChildContext() {
    return {
      csrfToken: cookies.get('CSRF3-Token'),
    };
  }

  render() {
    return (
      <div className="c-group-page">
        <SimpleCourseraMetatags title="Groups" />
        <div className="header-container">
          <PageHeader hideSearch hideEnterprise isHeaderFixedTop />
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default GroupPage;
